import { render, staticRenderFns } from "./CandidateAvatar.vue?vue&type=template&id=c9e754e8&scoped=true"
import script from "./CandidateAvatar.vue?vue&type=script&lang=ts"
export * from "./CandidateAvatar.vue?vue&type=script&lang=ts"
import style0 from "./CandidateAvatar.vue?vue&type=style&index=0&id=c9e754e8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9e754e8",
  null
  
)

export default component.exports